<template>
  <v-footer
    :height="$vuetify.breakpoint.xsOnly && isRunningAssignment ? 112 : 60"
    app
    inset
    class="py-2"
  >
    <v-btn
      :to="{ name: 'profile-assignments' }"
      exact
      width="150"
      large
      text
      color="primary"
    >
      <v-icon left>arrow_back</v-icon>
      Back
    </v-btn>
    <v-spacer />
    <v-chip
      v-if="isRunningAssignment"
      outlined
      class="d-inline-flex justify-center mr-2"
      style="width: 96px; font-family: monospace"
    >
      {{ timerValue }}
    </v-chip>
    <v-btn
      :disabled="!canRunTest"
      :loading="testLoading"
      :to="{ name: 'profile-assignment-test' }"
      :block="$vuetify.breakpoint.xsOnly && isRunningAssignment"
      :class="{ 'mt-2': $vuetify.breakpoint.xsOnly && isRunningAssignment }"
      width="150"
      large
      rounded
      color="primary"
      class="white--text"
    >
      <v-icon left>play_arrow</v-icon>
      Run test
    </v-btn>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AssignmentDetailsBottomToolbar',
  props: {
    assignment: {
      type: Object,
      default: () => ({}),
    },
    testLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('assignments', [
      'currentPeriodAssignments',
      'runningAssignments',
      'assignmentsTimers',
    ]),
    canRunTest() {
      if (!this.assignment) {
        return false;
      }
      const inTestPeriod = this.currentPeriodAssignments.some(a => a._id === this.assignment._id);
      if (!inTestPeriod) {
        return false;
      }
      const { reports = [] } = this.assignment;
      const finishedReports = reports.filter(r => r.finished);
      return finishedReports.length < this.assignment?.contentSettings?.maxAttempts;
    },
    isRunningAssignment() {
      return this.runningAssignments.some(a => a._id === this.assignment._id);
    },
    timerValue() {
      return this.assignmentsTimers[this.assignment._id]?.format('HH:mm:ss');
    },
  },
};
</script>
